export default "__VITE_ASSET__1f3c7ba3__"